const tableColumnMetadata: any[] = [
  { key: 'fecha', displayName: 'Fecha' },
  { key: 'phone', displayName: 'Teléfono' },
  { key: 'name', displayName: 'Nombre' },
  { key: 'nameUnit', displayName: 'Unidad' },
  { key: 'business', displayName: 'Empresa' },
  { key: 'nameTicket', displayName: 'Ticket' },
  { key: 'code', displayName: 'N° Ticket' }
];
export default tableColumnMetadata;
